exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bootom[data-v-407369c6] {\n  padding: 2rem;\n  text-align: center;\n}\n", ""]);

// exports
